export default __webpack_public_path__ + "static/media/contour.2803bc75.png";